import React from "react";
import {Typography, Divider} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";


const SurveyHeader = ({title, styles, loading}) => {
    return (
        loading ? (
            <Skeleton animation={"wave"}/>
        ) : (
            <div
                style={{
                    background: styles.background,
                    textAlign: styles.textAlign,
                    padding: styles.padding
                }}>
                <Typography style={{
                    padding: 5,
                    color: styles.color,
                    fontWeight: styles.fontWeight,
                    fontStyle: styles.fontStyle,
                    fontSize: styles.fontSize
                }}>
                    {title}
                </Typography>
                <Divider/>
            </div>
        )
    )
};
export default SurveyHeader;